module.exports = __webpack_public_path__ + "img/figure02_sp.c9a4135e.png";